import { PromotionalMaterialTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { PromotionalMaterialType } from '@/services/graphql/types';

export const mapperPromotionalMaterialTypeDataEnum = createEnumMapperFunction(
  PromotionalMaterialType,
  PromotionalMaterialTypeDataEnum
);
